import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { ConsentApprovalComponent } from './consent-approval.component';

import { PageTitleResolver } from '@iss/wo-common/routing';

const routes: Routes = [
  {
    path: '',
    component: ConsentApprovalComponent,
    title: PageTitleResolver,
    data: {
      title: 'page.consent-approval',
    },
  },
];

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ],
})
export class ConsentApprovalRoutingModule {}
